import ordersMasterService from '../orders/ordersMasterService';

const PROVIDER = 'APPLE_PAY';

const getApplePaySession = (cartId, isDraft) =>
  ordersMasterService.callToMethod(
    {
      cartId,
      isDraft,
      methodName: ordersMasterService.methodsMap.authorizeSession,
      paramsObject: { provider: PROVIDER },
    },
  );

const applePayService = {
  getApplePaySession,
};

export default applePayService;
